import { Account } from '@/domain/usecases'
import { upgradeRequestService } from '@/data/services/upgrade/upgrade-service'
import { formatUpgradeRequestSettings } from '@/data/services/upgrade/upgrade-service-utils'
import { requestSettingsQueryOptions } from '@/data/services/request-settings/request-settings-service'
import { queryClient } from '@/infra/http'

/**
 * Loads upgrade request data
 * Fetches upgrade settings and pending requests for user's company
 */
export async function loadUpgradeRequest(account: Account.Model) {
  const [upgradeSettings, upgradeRequestStatus] = await Promise.all([
    queryClient.fetchQuery(requestSettingsQueryOptions(account.company.uniqueId)),
    upgradeRequestService.fetchPendingRequests(account.company.uniqueId)
  ])

  return {
    ...formatUpgradeRequestSettings(upgradeSettings),
    pendingResponse: upgradeRequestStatus
  }
}
